import { useMediaQuery } from './use-media-query';

/** Tailwind `sm` breakpoint (640px). */
export const SM_MIN_WIDTH_MEDIA = '(min-width: 640px)' as const;

/**
 * `true` when the viewport is at least Tailwind `sm` (640px).
 * SSR-safe: `false` until after hydration on the client so the first paint
 * matches server HTML (mobile-first body).
 */
export function useMinWidthSm() {
  return useMediaQuery(SM_MIN_WIDTH_MEDIA);
}